import * as React from 'react'

export function AIIcon({
  fill = '#8E24AA',
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      role="img"
      aria-label="Agreement icon"
      {...props}
    >
      <path
        d="M15.834 7.49967L16.8757 5.20801L19.1673 4.16634L16.8757 3.12467L15.834 0.833008L14.7923 3.12467L12.5007 4.16634L14.7923 5.20801L15.834 7.49967ZM9.58398 7.91634L7.50065 3.33301L5.41732 7.91634L0.833984 9.99967L5.41732 12.083L7.50065 16.6663L9.58398 12.083L14.1673 9.99967L9.58398 7.91634ZM15.834 12.4997L14.7923 14.7913L12.5007 15.833L14.7923 16.8747L15.834 19.1663L16.8757 16.8747L19.1673 15.833L16.8757 14.7913L15.834 12.4997Z"
        fill={fill}
      />
    </svg>
  )
}
